
import debounce from '../../front/js/debounce'
import qs from 'qs'
import { normalizeSearchResponse, searchResponseIsEmpty } from '../js/search_response'
export default
  name: 'search-form'
  props:
    action: String
    placeholder: String
    term: String
    size: {type: String, default: ''}
    splitTerms: {type: Boolean, default: false}

  data: ->
    searchTerm: null
    q: {}

  computed:
    debouncedSearch: -> debounce((=> @search()), 500)
  methods:
    processSearchTerm: ->
      if @splitTerms
        return @searchTerm.split(/[\s,]+/)
      return @searchTerm
    search: ->
      @$emit('is-busy', true)
      term = @processSearchTerm()
      @$emit('search-term', term)
      params = {q: @q}
      axios_config = {
        params: params,
        paramsSerializer: (params) =>
          qs.stringify(params, {arrayFormat: 'brackets', encode: false})
      }
      @axios.get(@action, axios_config)
        .then (res) =>
          @$emit('update', normalizeSearchResponse(res.data))
          @$emit('empty-result', searchResponseIsEmpty(res.data))
        .catch (e) -> console.log e
        .finally => @$emit('is-busy', false)

  watch:
    term: (newTerm, oldTerm) ->
      @$delete(@q, oldTerm) if oldTerm
      @q[newTerm] = @searchTerm
      @debouncedSearch() if @searchTerm and @searchTerm.trim() isnt ''

    searchTerm: (newTerm, oldTerm) ->
      if '' == newTerm
        delete @q[@term]
        @$emit('search-term-empty', true)
      else
        @q[@term] = @searchTerm
        @$emit('search-term-empty', false)
        @debouncedSearch()

